async function toggleSelection(mattressId, mattressHandle) {
    const parentSectionElements = document.querySelectorAll('.variable-section');
    const processedSections = new Set();
    const promises = [];
  
    parentSectionElements.forEach(parentSectionElement => {
      const sectionId = parentSectionElement.getAttribute('data-section');
  
      if (processedSections.has(sectionId)) {
        return;
      }
      processedSections.add(sectionId);
  
      const productId = mattressId;
      const productHandle = mattressHandle;
      const pageType = window.location.pathname.split('/')[window.location.pathname.split('/').length - 2];
  
      const promise = fetch(`/${pageType}/${productHandle}?sections=${sectionId}&product_id=${productId}`)
        .then(response => response.json())
        .then(responseData => {
          const content = responseData[sectionId];
          const parser = new DOMParser();
          const docFragment = parser.parseFromString(content, 'text/html');
          const newElement = docFragment.body.firstChild;
  
          const targetElement = newElement.querySelector(`#mattress-type-selector [data-product-id='${productId}']`);
          if (targetElement) {
            targetElement.setAttribute('data-active', 'true');
            for (let sibling of targetElement.parentNode.children) {
              if (sibling !== targetElement) {
                sibling.setAttribute('data-active', 'false');
              }
            }
          }
  
          const sectionElement = parentSectionElement.classList.contains('variable-media-modal')
            ? document.getElementById(parentSectionElement.id)
            : document.getElementById(parentSectionElement.parentNode.id);
  
          newElement.style.opacity = 0;
          newElement.style.transition = 'opacity 0.3s ease-in-out';
          sectionElement.replaceWith(newElement);
          newElement.style.opacity = 1;
  
          if (targetElement) {
            targetElement.dispatchEvent(new Event("toggle-action-updated", { bubbles: true }));
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
  
      promises.push(promise);
    });
  
    await Promise.all(promises);
  
    const delayedMediaElements = document.querySelectorAll('.delayed-media');
    delayedMediaElements.forEach(delayedMediaElement => {
      delayedMediaElement.style.display = 'inline';
    });
    
    const Yotpoapi = new Yotpo.API(yotpo);
    Yotpoapi.refreshWidgets();
    affirm.ui.refresh();
  }

(function() {
  function parsePriceProducts(str) {
    // format: %%Twin ** 342//760--%%Twin XL ** 587//1304--...
    var map = {};
    if (!str) return map;
    str.split('--').forEach(function(entry) {
      var parts = entry.split(' ** ');
      if (parts.length < 2) return;
      var size = parts[0].replace('%%', '').trim();
      var salePrice = parseFloat(parts[1].split('//')[0].trim());
      if (size && !isNaN(salePrice)) map[size] = Math.round(salePrice * 100);
    });
    return map;
  }

  function formatMoney(cents) {
    var n = cents / 100;
    return '$' + (cents % 100 === 0 ? Math.round(n).toLocaleString('en-US') : n.toFixed(2));
  }

  function updateUpgradePrices(selectedVariantId) {
    var variantData = {}, priceData = {};
    for (var i = 1; i <= 4; i++) {
      var vel = document.getElementById('variants-product-variant-c-' + i);
      if (vel) { try { variantData[i] = JSON.parse(vel.textContent); } catch(e) {} }
      var pel = document.getElementById('price-products-variant-c-' + i);
      if (pel) priceData[i] = parsePriceProducts(pel.textContent.trim());
    }
    if (!Object.keys(variantData).length) return;

    var currentProductNum = null, currentSize = null;
    for (var j = 1; j <= 4; j++) {
      var variants = variantData[j] || [];
      for (var k = 0; k < variants.length; k++) {
        if (String(variants[k].id) === String(selectedVariantId)) {
          currentProductNum = j;
          currentSize = variants[k].option1;
          break;
        }
      }
      if (currentProductNum) break;
    }
    if (!currentProductNum || !currentSize) return;

    var currentPrice = (priceData[currentProductNum] || {})[currentSize];
    if (!currentPrice) return;

    var upgradeMap = {
      1: [[2,'product-version-c-2'],[3,'product-version-c-3'],[4,'product-version-c-4']],
      2: [[3,'product-version-c-3'],[4,'product-version-c-4']],
      3: [[4,'product-version-c-4']]
    };
    (upgradeMap[currentProductNum] || []).forEach(function(slot) {
      var upgradePrice = (priceData[slot[0]] || {})[currentSize];
      if (!upgradePrice || upgradePrice <= currentPrice) return;
      var span = document.getElementById(slot[1]);
      if (span) span.textContent = 'Upgrade for +' + formatMoney(upgradePrice - currentPrice);
    });
  }

  function init() {
    var input = document.querySelector('input[name="id"]');
    if (!input) return;
    updateUpgradePrices(input.value);
    input.addEventListener('change', function() { updateUpgradePrices(this.value); });
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) updateUpgradePrices(e.detail.variant.id);
    });
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
